import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage } from '../../../store/actions/messages.actions';
import { faqWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';
import { archiveFaq, setFaqsRefresh } from '../../../store/actions/faq.actions';

function addressAndName(address, name) {
  return address + ', ' + name;
}

const QuestionDeleteDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action1, actionId1 } = useParams();

  const editPermission = useSelector(faqWritePermission);

  const faqs = useSelector((state) => state.faq.list);
  const [faqSelected, setFaqSelected] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);

  // state effect
  useEffect(() => {
    const faqFromList = actionId1 && (faqs.find((item) => item.id === actionId1));
    if (action1 === 'delete') {
      setDeleteDialog(true);
    } else if (deleteDialog) {
      setDeleteDialog(false);
    }
    if (action1 === 'delete' && actionId1) {
      setFaqSelected({
        ...faqFromList,
      });
    }
  }, [action1, actionId1, faqs]);

  const onDeleteFaq = async () => {
    try {
      await store.dispatch(archiveFaq(actionId1));
      dispatch(showMessage({ open: true, text: 'Вопрос успешно удалён', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setFaqsRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось удалить. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* delete dialog */}
      <Dialog {...props} open={deleteDialog} onClose={handleClose} disableRestoreFocus>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Удалить вопрос из Популярных вопросов?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Вопрос </span>
            <strong>{faqSelected.title}</strong>
            <span> будет удалён</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={handleClose}
                >
                  Отменить
                </Button>
              )}
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="purple"
                  fullWidth
                  onClick={onDeleteFaq}
                >
                  Удалить
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

QuestionDeleteDialog.propTypes = {
  handleClose: PropTypes.func,
};

QuestionDeleteDialog.defaultProps = {
  handleClose: null,
};

export default memo(QuestionDeleteDialog);
